// src/pages/blog/{wpPost.slug}.js
import React, { useEffect, useRef, useState } from "react";
import { graphql, Link } from "gatsby";
import Layout from "../../components/layout";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Seo } from "../../components/seo";
import TableOfContent from "../../components/TableOfContent";
import Adsterra from "../../components/Adsterra";
import RelatedPosts from "../../components/RelatedPosts";
import SocialShare from "../../components/SocialShare";
import AuthorImage from "../../images/author.webp";
// import ReadingPercent from "../../components/ReadingPercent";

const BlogPost = ({ data }) => {
  const { title, content, date, toc, relatedPosts, slug, seo } = data.wpPost;
  const articleRef = useRef(null);
  const [articleHeight, setArticleHeight] = useState(0);
  // const [bodyHeight, setBodyHeight] = useState(0);

  const image = getImage(
    data.wpPost.featuredImage?.node.localFile.childImageSharp.gatsbyImageData
  );

  // useEffect(() => {
  //   const bodyHeight = document.body.scrollHeight;
  //   setBodyHeight(bodyHeight);
  // }, []);

  useEffect(() => {
    if (articleRef.current) {
      const height = articleRef.current.offsetHeight;
      setArticleHeight(height);
      console.log("Article Height:", height);
    }
  }, []);

useEffect(() => {
  const article = document.querySelector(".article");
  article.addEventListener("scroll", () => {
    const scrollPosition = article.scrollTop;
    console.log("Current scroll position:", scrollPosition);
  });

})
  return (
    <Layout>
      <div className="relative" ref={articleRef}>
        {/* <ReadingPercent articleHeight={articleHeight} /> */}
        <div>
          {/* breadcrumb */}
          <div className="mb-thin text-[16px] ">
            <Link to="/">
              <p className="text-[#3f4c61] inline">Home &gt; </p>
            </Link>
            <Link to={"/blog"}>
              <p className="text-[#3f4c61] inline">Blog &gt; </p>
            </Link>{" "}
            <span>{title}</span>
          </div>
          <h1 className="text-[24px] md:text-[48px] md:leading-[56px] leading-[32px] font-normal mb-thin max-w-[900px] ">
            {title}
          </h1>
          <p className="text-[16px] md:text-[18px] md:leading-[1.5] leading-normal max-w-[1000px] mb-thin text-[#677389] max-sm:mb-normal ">
            {" "}
            {seo.metaDesc}{" "}
          </p>
          <div className="flex justify-start items-center text-[#97989F] text-sm gap-x-8 gap-y-2 flex-wrap mb-normal pl-normal">
            <div className="flex justify-start items-center gap-2">
              <div className="rounded-full overflow-hidden h-8 w-8">
                {/* <img src="/images/author.webp" alt="" loading="lazy" /> */}
                <img src={AuthorImage} alt="medagui" />
                <img src="" alt="" loading="lazy" />
              </div>
              <p className="text-[16px] "> {data.wpPost.author.node.name} </p>
            </div>
            <p className="text-[16px]"> {date} </p>
          </div>

          {data.wpPost.featuredImage ? (
            <div className="rounded-[8px] overflow-hidden h-full">
              <GatsbyImage
                image={
                  image
                    ? image
                    : data.wpPost.featuredImage.node.localFile.childImageSharp
                        .gatsbyImageData
                }
                className="h-full w-full object-cover rounded-[8px] -scale-x-100"
                alt={
                  data.wpPost.featuredImage
                    ? data.wpPost.featuredImage.node.altText
                    : ""
                }
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="lg:flex mt-thin ">
          <article className="slide-in">
            {/* <TableOfContent toc={toc} add_class="lg:hidden" /> */}

            <div
              dangerouslySetInnerHTML={{ __html: content }}
              className="mt-thin text-[16px] leading-[160%] font-normal article "
            />
            <SocialShare slug={slug} title={title} />
            <div className="w-full flex justify-center items-center py-normal ">
              <div className="h-[250px] w-[300px] bg-ad -mx-normal">
                <Adsterra
                  slot="e9972fe10298e2a37dff42a21503b711"
                  add_class="mt-auto"
                />
              </div>
            </div>
            <RelatedPosts data={relatedPosts.nodes} />
          </article>
          <aside
            className={`pl-8 max-lg:hidden xl:min-w-[450px] lg:min-w-[33vw] relative flex flex-col justify-start items-center`}
          >
            <TableOfContent toc={toc} add_class="sticky top-[100px] left-0" />
            <div className="h-[300px] w-[160px] bg-ad mt-normal">
              <Adsterra slot="c75753797622ae4d821ba688b5a8b8b3" />
            </div>
          </aside>
        </div>
      </div>
    </Layout>
  );
};

export const Head = ({ data }) => {
  return (
    <Seo
      title={`${data.wpPost.title} | Garden Hub`}
      description={`${data.wpPost.seo.metaDesc}`}
      canonicalUrl={`/blog/${data.wpPost.slug}`}
      // image={data.wpPost.featuredImage.node.}
    />
  );
};

export const query = graphql`
  query ($slug: String!) {
    wpPost(slug: { eq: $slug }) {
      author {
        node {
          avatar {
            url
          }
          name
        }
      }
      categories {
        nodes {
          name
        }
      }
      content
      date(formatString: "MMM DD YYYY")
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              gatsbyImageData(
                width: 1200
                placeholder: DOMINANT_COLOR
                formats: WEBP
              )
            }
          }
          title
        }
      }
      relatedPosts {
        nodes {
          excerpt
          title
          slug
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 320
                    placeholder: DOMINANT_COLOR
                    formats: WEBP
                  )
                }
              }
            }
          }
        }
      }
      slug
      seo {
        title
        metaDesc
      }
      title
      toc
    }
  }
`;

export default BlogPost;
